import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';

type LocationConnectionHistorySummaryItemProps = {
  value: number;
  label: string;
  color: string;
};

export const LocationConnectionHistorySummaryItem = ({
  value,
  label,
  color,
}: LocationConnectionHistorySummaryItemProps) => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      flex={1}
      boxSizing='border-box'
      sx={({ palette, spacing }) => ({
        p: spacing(0, 3),
        flexFlow: 'column nowrap',

        '&:not(:last-child)': {
          borderRight: `1px solid ${palette.divider}`,
        },
      })}
    >
      <Typography variant='subtitle1' fontWeight={400} gutterBottom>
        {label}
      </Typography>
      <Typography variant='h4' color={color}>
        {value}
      </Typography>
    </Box>
  );
};
